import React, { useState } from "react";
import { Dropdown, Button, Modal } from "react-bootstrap";
import ChangePassword from "../Components/ChangePassword";
import AvatarImage from "../assets/images/ava-header.png";
import { ReactComponent as LogoutSvg } from "../assets/images/logout.svg";
import { ReactComponent as ChangePasswordSvg } from "../assets/images/lock.svg";
import { ReactComponent as UserSvg } from "../assets/images/user.svg";
import { useSelector } from "react-redux";

export default function Navbar() {
  const user = useSelector((state) => state.authentication.user);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div className="navbar d-flex justify-content-between align-items-center">
      <h6 className="m-0">Welcome, {user?.fullname}</h6>{" "}
      <Dropdown>
        <Dropdown.Toggle variant="Secondary" id="dropdown-basic">
          <div className="profile-image-wrap">
            <img src={AvatarImage} alt="profile avatar" />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item>
            <Button className="changebtn d-flex">
              <div className="svgwarp drop mr-3">
                <UserSvg />
              </div>
              {user?.email}
            </Button>
          </Dropdown.Item>
          <Dropdown.Item>
            <Button className="changebtn d-flex" onClick={handleShow}>
              <div className="svgwarp drop mr-3">
                <ChangePasswordSvg />
              </div>
              Change Password
            </Button>
          </Dropdown.Item>
          <Dropdown.Item>
            <Button className="changebtn d-flex" onClick={() => {localStorage.removeItem("token");window.location.href = "/";}}>
              <div className="svgwarp drop mr-3">
                <LogoutSvg />
              </div>
              Logout
            </Button>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ChangePassword />
        </Modal.Body>
      </Modal>
    </div>
  );
}
